import React, { useState } from 'react'

import { UserProvider } from './user-context'
import UserEdit from './edit-user/edit-user'
import UserSelect from './user-select/user-select'
import UserCreation from './create-user/create-user'

interface UserPageProps {
  fromForm: boolean
}

const UserPage: React.FC = ({ fromForm }: UserPageProps) => {
  const [users, setUsers] = useState([])
  const [contactUsers, setContactUsers] = useState([])
  const [contactRoles, setContactRoles] = useState({})
  const [modifiedUsers, setModifiedUsers] = useState([])
  const [contacts, setContacts] = useState([])
  const [selectedContact, setSelectedContact] = useState({
    id: '',
    name: '',
    roles: [],
  })

  const selectedView = () => {
    switch (selectedContact.id) {
      case '':
        return <UserSelect fromForm={fromForm} />
      case 'newUser':
        return <UserCreation />
      case selectedContact.id:
        return <UserEdit />
      default:
        return <UserEdit />
    }
  }

  return (
    <UserProvider
      value={{
        users,
        setUsers,
        contactRoles,
        setContactRoles,
        modifiedUsers,
        setModifiedUsers,
        contacts,
        setContacts,
        selectedContact,
        setSelectedContact,
        contactUsers,
        setContactUsers,
      }}
    >
      {selectedView()}
    </UserProvider>
  )
}

export default UserPage
